import S from "string";

export const camelToSnakeCase = str =>
  str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const objectKeysFromCamelToSnakeCase = (object = {}) =>
  Object.fromEntries(
    Object.entries(object).map(([key, value]) => [camelToSnakeCase(key), value])
  );

export const transformKeyUnderscore = (value, key) => {
  return S(key).underscore().s;
};
